module.exports = __webpack_public_path__ + "media/assets/player/play-cdd70de87bac771ec1d4665775f271f9.svg";